import React from 'react';
import { amazonLink } from './constants/Constants';

function Justly() {
    const cards = require("./images/cards.png");
    const star = require("./images/star.png");
    const peopleIcon = require("./images/people.png");
    const cardIcon = require("./images/card.png");

    const handleOrder = async () => {
        window.open(amazonLink, '_blank');
    }

    return (
        <div className="justlyOuterWrapper">
            <div className="justlyInnerWrapper">
                <div className="justlyNameDescriptionWrapper">
                    <div className="justlyNameDescription1">A GAME OF</div>
                    <div className="justlyNameDescription2">ROASTING</div>
                </div>
                <div className="justlyRightStarWrapper">
                    <img className="justlyStar" src={star} alt="star"/>
                </div>
                <div className="justlyLeftStarWrapper">
                    <img className="justlyStar" src={star} alt="star"/>
                </div>
                <div className="justlyCardsWrapper">
                    <img className="justlyCards" src={cards} alt="cards"/>
                </div>
                <button className="justlyOrderButton" onClick={handleOrder}>ORDER NOW</button>
                <div className="justlyQuickInfoWrapper">
                    <div className="justlyQuickInfo">
                        <img className="justlyQuickInfoIcon" src={peopleIcon} alt="people"/>
                        <div className="justlyQuickInfoText">4-8 players</div>
                    </div>
                    <div className="justlyQuickInfo">
                        <img className="justlyQuickInfoIcon" src={cardIcon} alt="card"/>
                        <div className="justlyQuickInfoText">600 handpicked cards</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Justly;